import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { QueryParamsBase } from "@/types/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getIngredients } from "./api";

const STALE_TIME_BASE = 1000 * 60 * 10; // 10 minutos

export function useIngredients(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: ["ingredients", { params: paramsQuery, select }],
    queryFn: () => getIngredients({ ...paramsQuery, select }),
    staleTime: isBaseQuery ? 0 : 0,
    gcTime: isBaseQuery ? 0 : 0,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}
